const ArticleLeaveComment = () => {
  const leaveCommentBtn = document.querySelector(".article-comments__leave-comment-btn");
  const leaveCommentFormWrapper = document.querySelector(".article-comments__form-wrapper");

  if (leaveCommentBtn) {
    leaveCommentBtn.addEventListener("click", () => {
      leaveCommentFormWrapper.classList.add("opened");
    })
  }
}

export default ArticleLeaveComment;